import { UserPreferences } from 'src/models/userInterfaceSettings';

import { Callback } from 'src/util/query/models/Callback';

export class GetTheUserPreferencesQueryCallBack extends Callback<UserPreferences[]> {
	public constructor(private readonly applyUserPreferences: (preferences: UserPreferences | undefined) => void) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: UserPreferences[]): void => {
		this.applyUserPreferences(successResponse.pop());
	};
}
